
define('text!templates/modules/calendar/personal-data/manager/edit/personal-data-edit-content.html',[],function () { return '<div class="panel-body personal-data-edit-content">\n    <ul class="menu-actions nav nav-pills"></ul>\n    <div class="personal-data-alert"></div>\n    <div class="personal-data-edit-form"></div>\n</div>\n';});

